<template>
    <div class="container" v-title="'身份认证'">
        <Navigation-bar></Navigation-bar>
        <div class="container_content">
            <Title title="身份认证" subtitle="信息实名认证"></Title>
            <div id="IdentityAuthentication" v-show="show">
                <template v-if="!isRealName">
                    <div class="content">
                        <ul>
                            <li>
                                <div class="item-input">
                                    <input type="text" :class="{'error' : nameHint}" v-model.trim="name" placeholder="请输入真实姓名">
                                </div>
                                <p class="errorHint" v-show="nameHint" v-text="nameHint"></p>
                            </li>
                            <li>
                                <div class="item-input">
                                    <input type="text" :class="{'error' : IDCardHint}" v-model.trim="IDCard" @blur="IDCardBlur" placeholder="请输入身份证号" maxlength="18">
                                </div>
                                <p class="errorHint" v-text="IDCardHint"></p>
                            </li>
                        </ul>
                    </div>
                    <div class="operation">
                        <button @click="send()">提交</button>
                    </div>
                </template>
                <div class="authentication" v-else>
                    <div>
                        <h3>{{realNameText}}</h3>
                        <p>{{identityNoText}}</p>
                        <div>
                            <YD-image src="icon/icon_已认证"></YD-image>
                            <span>已认证</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>
import {
    UserSetIdentity,
    UserGetIdentity
} from "@/api"
import {
    textEncryption,
    identityCard
} from '@js';
export default {
    name:"IdentityAuthentication",
    data(){
        return {
            show:false,
            name:'',
            nameHint:'',
            IDCard:'',
            IDCardHint:'',
            IdentifyInfo:{}
        }
    },
    created(){
        UserGetIdentity().then(data=>{
            if(data.Code == 0){
                this.show = true;
                if(data.IdentifyInfo){
                    this.IdentifyInfo = data.IdentifyInfo;
                }
            }
        })
    },
    watch:{
        name:function(newVal){
            if(!newVal){
                this.nameHint = '请输入姓名';
            }else{
                this.nameHint = '';
            }
        }
    },
    computed:{
        isRealName(){
            return this.IdentifyInfo && this.IdentifyInfo.IdentityAuthResult == 1;
        },
        realNameText:function(){
            var RealName = this.IdentifyInfo._RealName;
            if(RealName.length > 2){
                return textEncryption(RealName, 1, 1, ' * ');
            }else{
                return textEncryption(RealName, 1, 0, ' *');
            }
        },
        identityNoText:function(){
            return textEncryption(this.IdentifyInfo._IdentityNo, 3, 4, '****');
        }
    },
    methods:{
        IDCardBlur(){
            this.IDCardHint = '';
            if(!this.IDCard){
                this.IDCardHint = '请输入身份证号';
                return false;
            }else if(!identityCard(this.IDCard)){
                this.IDCardHint = '身份证号格式有误';
                return false;
            }
        },
        send(){
            this.nameHint = '';
            let name = this.name;
            if(!name){
                this.nameHint = '请输入姓名';
                return;
            }else if(name.length < 2){
                this.nameHint = '姓名不能少于两个字';
                return;
            }
            if(this.IDCardBlur() == false)return;
            UserSetIdentity({
                "IdentifyInfo": {
                    "_RealName": name,
                    "IdentityType": 1,
                    "_IdentityNo": this.IDCard
                }
            }).then(data=>{
                if(data.Code == 0){
                    if(data.IdentityAuthResult == 1){
                        this.$Toast('实名认证成功','success');
                        setTimeout(()=>{
                            this.$navigation.back();
                        },1000)
                    }else{
                        this.$Toast('请检查您的姓名和身份证号码是否正确', 'error');
                    }
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
#IdentityAuthentication {
    .content{
        height: 70%;
        min-height: 400px;
        max-height: 700px;
        padding-top: 40px;
        ul{
            li{
                width: 670px;
                margin: 0 auto;
                margin-bottom: 32px;
                .item-input{
                    width: 670px;
                    height: 108px;
                    position: relative;
                    input{
                        width: 100%;
                        height: 100%;
                        background: #F9F9F9;
                        border-radius: 20px;
                        padding: 0 32px;
                        font-size: 32px;
                        box-sizing: border-box;
                        &.error{
                            background: rgba(240,110,67,0.1);
                        }
                    }
                }
                .errorHint{
                    @include line-height(40px);
                    font-size: 28px;
                    font-weight: 400;
                    color: #F06E43;
                    margin-top: 8px;
                }
            }
        }
    }
    .operation{
        height: 92px;
        width: 100%;
        button{
            @include btn-type-large;
            background: #F5F7F5;
            color: #1B1C1E;
        }
    }
    .authentication{
        width: 100%;
        height: 100%;
        max-height: 550px;
        display: flex;
        align-items: center;
        justify-content: center;
        >div{
            text-align: center;
            h3{
                font-size: 60px;
                color: #1B1C1E;
                font-weight: 500;
                line-height: 84px;
            }
            p{
                font-size: 32px;
                color: #8B8C8D;
                letter-spacing: 1px;
                line-height: 44px;
                font-weight: 500;
                margin-top: 16px;
            }
            >div{
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 32px;
                color: #7AD21A;
                text-align: center;
                font-weight: 500;
                margin-top: 26px;
                img{
                    width: 56px;
                    height: 56px;
                    margin-right: 10px;
                }
            }
        }
    }
}
</style>